import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cookie di sessione HttpOnly: withCredentials invia i cookie, MAI localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Rinnovo silenzioso della sessione: se l'access token e' scaduto (401), prova
// UNA sola volta /auth/refresh (usa il refresh_token cookie, vita piu' lunga)
// e ripete la richiesta originale. Cosi' l'utente non vede piu' un album/figurine
// vuoti solo perche' la sessione di 30 minuti e' scaduta durante la visita.
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const isAuthRoute = config?.url?.includes("/auth/login") || config?.url?.includes("/auth/refresh");
    if (response?.status === 401 && config && !config._retried && !isAuthRoute) {
      config._retried = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").finally(() => {
            refreshPromise = null;
          });
        }
        await refreshPromise;
        return api(config);
      } catch {
        // refresh fallito (sessione davvero scaduta): lascia gestire l'errore 401 a chi ha chiamato.
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
